import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-view-source-material',
  templateUrl: './view-source-material.component.html',
  styleUrls: ['./view-source-material.component.css']
})
export class ViewSourceMaterialComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  materialList: any = [];
  constructor(
    private router: Router,  //路由跳转
    private box: SwMassageBoxService,  //消息提示框
    private service: KmsService,   //请求服务
  ) { 

  }

  ngOnInit() {
    this.clickLoca(this.param["selectedData"]);
  }

  clickLoca(selectedData: any) {
    // 查询任务详情
    this.service.queryExtractMaterialList(selectedData.taskId).subscribe(
      data => {
        if (data["code"] == '200') {
          if (data["data"].length > 0) {
            let res = data["data"];
            res.forEach(e => {
              let pageNums = e.pagesNumStr.split(",").map(Number).sort((a,b) => {return a - b})
              this.materialList.push({materialId: e.materialId, materialTitle: e.materialTitle, pageNums: pageNums});
            });
          }
        }
      }
    )
  }

  // 查看详情  type: resource 查看资源详情；content 素材内容浏览
  clickViewDetail(item){
    this.modal.toggle();
    this.callback.emit(true);
    let params = {
      materialId: item.materialId,
      current: 1
    };
    this.router.navigate(['/kms/KnowledgeExtract'], {queryParams: {Title: '素材浏览', selectData: JSON.stringify(params)}});
  }
}



